import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Loader from '../../marvel-ui-loader/Loader';

import generalStyles from './style/general.css';

import { SadFace } from '../icons';
import { buttonSize } from '../sizes.spec';

export default function ExtraElement({
  fullWidth,
  icon,
  isHovered,
  isIconCentered,
  isLoading,
  isSad,
  size,
}) {
  const extraElementStyle = {
    width: fullWidth ? '100%' : buttonSize[size],
    height: buttonSize[size],
  };

  const extraElementClasses = cx({
    [generalStyles.extraElementWrap]: !isIconCentered,
    [generalStyles.extraElementInlineWrap]: isIconCentered,
  });

  const iconClasses = cx({
    [generalStyles.extraElement]: !isIconCentered,
  });

  const sadIconClasses = cx(generalStyles.sadIcon, {
    [generalStyles.sadIconHidden]: !isHovered,
  });

  if (isIconCentered) {
    return (
      <div className={iconClasses}>
        {isLoading ? <Loader size={size} /> : icon}
      </div>
    );
  } else if (isSad) {
    return (
      <div className={extraElementClasses} style={extraElementStyle}>
        <div className={iconClasses}>
          {isLoading ? (
            <Loader size={size} />
          ) : (
            <div className={sadIconClasses}>
              <SadFace size={size} />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={extraElementClasses} style={extraElementStyle}>
      <div className={iconClasses}>
        {isLoading ? <Loader size={size} /> : icon}
      </div>
    </div>
  );
}

ExtraElement.propTypes = {
  fullWidth: PropTypes.bool,
  icon: PropTypes.node,
  isHovered: PropTypes.bool,
  isIconCentered: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSad: PropTypes.bool,
  size: PropTypes.string,
};

ExtraElement.defaultProps = {
  fullWidth: false,
  icon: null,
  isHovered: false,
  isIconCentered: false,
  isLoading: false,
  isSad: false,
  size: 'medium',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/ExtraElement/index.js